import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function LockIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M18 9.5V6.5C18 3.19141 15.3086 0.5 12 0.5C8.69141 0.5 6 3.19141 6 6.5V9.5H3V14.5C3 19.4629 7.0376 23.5 12 23.5C16.9624 23.5 21 19.4629 21 14.5V9.5H18ZM8 6.5C8 4.29395 9.79443 2.5 12 2.5C14.2056 2.5 16 4.29395 16 6.5V9.5H8V6.5ZM19 14.5C19 18.3594 15.8599 21.5 12 21.5C8.14014 21.5 5 18.3594 5 14.5V11.5H19V14.5ZM11 14.5H13V18.5H11V14.5Z",
    fill: "currentColor"
  }));
}